<template>
  <!-- 学校风采详情 -->
  <div class="index-container">
    <bannerImg bannerText="大健康人才教育培训" :isShowTab="false"></bannerImg>
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 学校风采
        <span>> {{ detailInfo.title }}</span>
      </div>
      <div class="detail-container" v-if="detailInfo">
        <div class="left-content">
          <div class="info-module">
            <div class="top-box">
              <div class="date-box">
                <div class="num">{{ detailInfo.publish_day }}</div>
                <div class="text">{{ detailInfo.publish_month }}</div>
              </div>
              <div class>
                <div class="detail-title">{{ detailInfo.title }}</div>
                <div class="num-box">
                  <i class="iconfont el-icon-view"></i>
                  {{ detailInfo.pv }}
                  <i class="iconfont el-icon-chat-line-square"></i>
                  {{ detailInfo.comment_count }}
                </div>
              </div>
            </div>
            <div class="detail-img" v-if="detailInfo.vedio">
              <video oncontextmenu="return false;" :src="imgUrl + detailInfo.vedio" autoplay></video>
            </div>
            <div class="detail-words" v-html="detailInfo.detail"></div>
            <div class="bottom-box">
              <div>作者：{{ detailInfo.author }}</div>
              <div class="img-box">
                分享到
                <div
                  class="img-list"
                  @click="shareLink"
                  :style="{ backgroundImage: 'url( ' + item + ')' }"
                  v-for="(item, index) in imgList"
                  :key="index"
                ></div>
              </div>
            </div>
          </div>
          <div class="info-module">
            <div class="m-title">用户评论 （{{ listTotal }}）</div>

            <div class="comment-content">
              <el-input type="textarea" :rows="4" v-model="comment"></el-input>
              <div class="c-box">
                <el-rate
                  v-model="commentScore"
                  text-color="#FF9C00"
                  show-score
                  score-template="{value}.0"
                  :colors="scoreColor"
                ></el-rate>
                <div class>
                  <span>
                    <i class="iconfont-icon icon-biaoqing"></i>
                    表情
                    <div class="emo-box">
                      <VEmojiPicker @select="selectEmoji"></VEmojiPicker>
                    </div>
                  </span>
                  <div class="c-button" @click="publishComment">发表评论</div>
                </div>
              </div>
              <div class="comment-list" v-for="(item, index) in commentList" :key="'comment' + index">
                <div class="c-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.user.avatar + ')' }"></div>
                <div class="right-info">
                  <div class="c-name">
                    {{ item.user.real_name }}
                    <span>{{ item.create_time }}</span>
                  </div>
                  <el-rate v-model="item.evaluate" disabled :colors="scoreColor"></el-rate>
                  <div class="c-words">{{ item.detail }}</div>
                </div>
              </div>
              <el-pagination
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next"
                :page-size="page_size"
                :total="listTotal"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="module-title">热门动态</div>
          <div class="hot-list" @click="goDetail(item)" v-for="(item, index) in detailInfo.hot" :key="'hot' + index">
            <div class="hot-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.thumb + ')' }"></div>
            <div class="hot-name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bannerImg from "../components/bannerImg.vue";
import pengyouquan from "@/assets/img/pengyouquan.png";
import weibo from "@/assets/img/weibo.png";
import weixin from "@/assets/img/weixin.png";
import { VEmojiPicker } from "v-emoji-picker";
import { imgUrl } from "../api/index";
import api from "../api/api";

export default {
  name: "showDetail",
  components: {
    bannerImg,
    VEmojiPicker,
  },
  data() {
    return {
      imgUrl: imgUrl,
      hotList: [],
      imgList: [weixin, pengyouquan, weibo],
      comment: "",
      commentScore: 0,
      scoreColor: ["#FF9C00", "#FF9C00", "#FF9C00", "#FF9C00", "#FF9C00"],
      commentList: [],
      listTotal: 0,
      detailInfo: {
        publish_day: "",
        publish_month: "",
        title: "",
        pv: "",
        comment_count: "",
        thumb: "",
        detail: "",
        author: "",
      },
      page_index: 1,
      page_size: 6,
      detailId: "",
    };
  },
  created() {
    const value = this.$route.query;
    if (value) {
      this.detailId = value.id;
      this.getDetail();
      this.getArticleEvaluate();
    }
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    shareLink() {
      let domUrl = document.createElement("input");
      domUrl.value = window.location.href;
      domUrl.id = "creatDom";
      document.body.appendChild(domUrl);
      domUrl.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      let creatDom = document.getElementById("creatDom");
      creatDom.parentNode.removeChild(creatDom);
      this.$message.success("分享链接已复制！");
    },
    getDetail() {
      api.getArticleDetail({ uuid: this.detailId }).then((res) => {
        console.log(res);
        if (res.result) {
          this.detailInfo = res.result;
          this.detailInfo.detail = this.changeShowImg(this.detailInfo.detail);
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    changeShowImg(obj) {
      const baseImg = "https://train-service-api.procaregroup.com/";
      const objstr = JSON.stringify(obj);
      const midStr = "train_service/app_upload";
      const str = objstr.replace(new RegExp(baseImg, "g"), "");
      const str1 = str.replace(
        new RegExp(midStr, "g"),
        "https://train-service-api.procaregroup.com/train_service/app_upload"
      );
      return JSON.parse(str1);
    },
    // 发布评论
    publishComment() {
      const params = {
        article_uuid: this.detailId,
        evaluate: this.commentScore,
        detail: this.comment,
      };
      api.createArticleEvaluate(params).then((res) => {
        console.log(res);
        if (res.result) {
          this.commentScore = 0;
          this.comment = "";
          this.getDetail();
          this.getArticleEvaluate();
          this.$message.success("评论成功！");
        }
      });
    },
    // 获取评论列表
    getArticleEvaluate() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        article_uuid: this.detailId,
      };
      api.getArticleEvaluate(params).then((res) => {
        console.log(res);
        if (res.result) {
          this.commentList = res.result.data;
          this.listTotal = res.result.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getArticleEvaluate();
    },
    goDetail(item) {
      this.$router.push({ path: "/showDetail", query: { id: item.uuid } });
    },
    selectEmoji(emoji) {
      console.log(emoji);
      this.comment += emoji.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background: #f8f7f6;
}
.nav-box {
  margin-bottom: 40px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.index-content {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.detail-container {
  display: flex;
  justify-content: space-between;
}
.left-content {
  width: 66%;
  .info-module {
    padding: 30px 40px 40px;
    margin-bottom: 30px;
    background: #ffffff;
  }
  .m-title {
    position: relative;
    margin-bottom: 26px;
    font-size: 18px;
    color: #f6ab2b;
    font-weight: 500;
    &::before {
      position: absolute;
      top: 4px;
      left: -22px;
      width: 4px;
      height: 17px;
      background-color: #f6ab2b;
      content: "";
    }
  }
  .top-box {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .date-box {
    width: 70px;
    height: 66px;
    padding-top: 14px;
    margin-right: 14px;
    color: #f38134;
    text-align: center;
    background: #fcede3;
    border-radius: 11px;
    .num {
      padding-bottom: 4px;
      font-size: 36px;
      font-weight: bold;
      line-height: 20px;
    }
    .text {
      font-size: 18px;
    }
  }
  .detail-title {
    padding-bottom: 10px;
    font-size: 24px;
    font-weight: 500;
  }
  .el-icon-chat-line-square {
    padding-left: 16px;
  }
  .num-box {
    color: #666666;
  }
  .detail-img {
    width: 100%;
    height: 406px;
    margin-bottom: 26px;
    // background-color: antiquewhite;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .detail-words {
    padding-bottom: 38px;
    font-size: 16px;
    line-height: 28px;
    border-bottom: 1px solid #ebebeb;
  }
  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 0;
    font-size: 16px;
    color: #666666;
  }
  .img-box {
    display: flex;
    align-items: center;
  }
  .img-list {
    width: 36px;
    height: 36px;
    margin-left: 16px;
    border-radius: 50%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .c-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    margin-bottom: 34px;
    font-size: 18px;
    line-height: 44px;
    border-bottom: 1px solid #ebebeb;
    span {
      position: relative;
      cursor: pointer;
      &:hover {
        .emo-box {
          display: block;
        }
      }
    }
  }
  .emo-box {
    position: absolute;
    display: none;
    top: 24px;
  }
  .iconfont-icon {
    position: relative;
    top: 2px;
    font-size: 26px;
    color: #ff9c00;
  }
  .c-button {
    float: right;
    width: 103px;
    margin-left: 48px;
    font-size: 18px;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    background: #f6ab2b;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .comment-list {
    display: flex;
    margin-bottom: 20px;
    &:last-child {
      .c-words {
        border: none;
      }
    }
  }
  .c-img {
    width: 64px;
    height: 64px;
    background-color: wheat;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }
  .right-info {
    flex: 1;
    padding-left: 22px;
  }
  .c-name {
    padding-bottom: 4px;
    font-size: 16px;
    font-weight: bold;
    span {
      float: right;
      font-size: 14px;
      color: #999999;
      font-weight: normal;
    }
  }
  .c-words {
    padding: 10px 0 16px;
    line-height: 24px;
    border-bottom: 1px solid #ebebeb;
  }
}
.right-content {
  width: 30%;
  padding: 30px 22px 10px;
  margin-bottom: 18px;
  background: #ffffff;
  .hot-list {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    cursor: pointer;
    &:hover {
      .hot-name {
        color: #fb6d0a;
      }
    }
  }
  .hot-img {
    flex-shrink: 0;
    width: 50%;
    height: 85px;
    margin-right: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .hot-name {
    color: #2e2d2d;
    line-height: 24px;
  }
  .module-title {
    position: relative;
    margin-bottom: 26px;
    font-size: 18px;
    color: #f6ab2b;
    font-weight: 500;
    &::before {
      position: absolute;
      top: 4px;
      left: -22px;
      width: 4px;
      height: 17px;
      background-color: #f6ab2b;
      content: "";
    }
  }
}
/deep/ {
  .el-rate__icon {
    font-size: 20px;
  }

  .el-textarea__inner {
    background-color: #fafafa;
    border: 1px solid #d4d4d4;
    border-radius: 14px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-top: 40px;
    text-align: center;
    button {
      width: 42px;
      height: 42px;
    }
  }
  .el-pager li {
    width: 42px;
    height: 42px;
    line-height: 42px;
  }
}
@media screen and (max-width: 1600px) {
  .index-content {
    width: 96%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/showDetail.vue